import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-collection-vehicle',
  templateUrl: './skeleton-collection-vehicle.component.html',
  styleUrls: ['./skeleton-collection-vehicle.component.scss'],
})
export class SkeletonCollectionVehicleComponent {}
